var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{attrs:{"to":"/","custom":""},scopedSlots:_vm._u([{key:"default",fn:function({ navigate }){return [_c('a',{attrs:{"href":_vm.GetEMPFontendURL,"target":"_blank"}},[_c('img',{staticClass:"img-fluid",staticStyle:{"padding":"12px 24px"},attrs:{"loading":"lazy","src":_vm.LogoPath,"alt":"CPS+ eMarketplace"}})])]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }